import { type PropsWithChildren } from 'react';
import classnames from 'classnames';

import styles from './AttributesGrid.module.scss';

type AttributesGridProps = {
  className?: string;
};

// TODO: convert to tailwind
export const AttributesGrid = ({
  className,
  children,
}: PropsWithChildren<AttributesGridProps>) => {
  return (
    <div className={classnames(styles.attributesGrid, className)}>
      {children}
    </div>
  );
};
